export const SharedContent = {
  blockquoteHeading: {
    label: '877-662-7447',
    link: 'tel:+1-877-662-7447',
  },
  ariaLabels: {
    faqAccordion: 'Button to reveal answer',
    accountType: 'Show account type options',
    holdingSelect: 'Select holding',
    continueButton: 'Continue button',
    editButton: 'Edit button',
    backToTop: 'Back to top',
  },
  blockquoteText: '(M–F, 8 a.m. to 8 p.m, Eastern time)',
  breadcrumbPrefix: `Est. total transfer thus far: `,
  buttons: {
    continueButton: 'Continue',
    backButton: 'Back',
  },
  iraTransferChip: 'IRA transfer',
  progressLabelIT: 'Internal transfer progress',
  progressLabelDivorce: 'Divorce transfer progress',
  progressLabelITOpenAccount: 'Internal transfer progress (Open an account)',
  accountHatPrefix: 'New account ',
  checklistBullets: ['Full Social Security number', 'Birth date', 'Address'],
  checklistHeading: 'Important things to have ready',
  checklistDesc: `Before you call, you'll want to have the following information ready <span class="bold">for the person who passed away</span>:`,
  estimatedAccountBalance: `Est. balance as of`,
  invalidError: 'Your entry is invalid.',
  loadingSpinner: 'Loading...',
  requiredError: 'This field is required.',
  radioRequiredError: 'Make a selection to continue.',
  receiptHeader: `Summary of what you've told us so far`,
};
